import ApiRequest from '../api/request';

type Params = { route?: 'email'; action: 'load' | 'renderTemplate' | 'sendTemplate'; params: any };

export default class Email {
  /**
    Interact with email routes
    @note Parameters come in an object named params and may contain more than what is just labeled here
    look at actual method called for action to determine actual parameters
  */
  static async Interact(params: Params, apiToken: string) {
    console.log('\t\tEmail.Interact()');
    try {
      if (params.action === 'load') {
        return Email.Load(apiToken);
      }
      if (params.action === 'renderTemplate') {
        return Email.RenderTemplate(params.params, apiToken);
      }
      if (params.action === 'sendTemplate') {
        return Email.SendTemplate(params.params, apiToken);
      }
    } catch (err: any) {
      return { error: err.message };
    }
  }

  /**
    Load email model document and email templates
  */
  static async Load(apiToken: string) {
    try {
      const response = await ApiRequest.sendRequest({
        method: 'post',
        params: {},
        path: 'email/load',
        token: apiToken,
      });
      return response.data;
    } catch (err: any) {
      return { error: err.message };
    }
  }

  /**
    Load email model document and email templates
  */
  static async RenderTemplate(params: Params, apiToken: string) {
    try {
      const response = await ApiRequest.sendRequest({
        method: 'post',
        params,
        path: 'email/render-template',
        token: apiToken,
      });
      return response.data;
    } catch (err: any) {
      return { error: err.message };
    }
  }

  /**
    Load email model document and email templates
  */
  static async SendTemplate(params: Params, apiToken: string) {
    try {
      const response = await ApiRequest.sendRequest({
        method: 'post',
        params,
        path: 'email/send-template',
        token: apiToken,
      });
      return response.data;
    } catch (err: any) {
      return { error: err.message };
    }
  }
}
